<template>
  <div>
    <div class="container-fluid pt-0 row mx-0 bg-primary">
      <article class="container card my-4 mycard-scale">
        <page-breadcrumb :items="crumbs" />
        <h1 class="h3 my-3">专线及运费查询</h1>
        <p class="p2em">
          广西桂运宝科技有限公司总部在柳州，提供大宗整车网络货运。下面可以查询已录入的专线和运费参考。未覆盖的线路请拨打客服
          0772-2991568，业务合作 18178808555。
        </p>
      </article>
      <truckage-list />
    </div>
  </div>
</template>

<script>
import truckageList from "../components/truckageList.vue";
import { PAGES } from "@/seo/site";

/**
 * 专线运费查询页。查询结果仍由组件交互产生，不写入 sitemap。
 */
export default {
  components: { truckageList },
  name: "ShowTruckage",
  data: function () {
    return {
      crumbs: PAGES.truckage.crumbs,
    };
  },
};
</script>
